// src/pages/LoggedOutPage.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./LoggedOutPage.css";

const DOT_COLORS = ["#10b981", "#f59e0b", "#ef4444", "#3b82f6", "#8b5cf6"];

const WORDWALL_PHRASE = 'the ambitious, hustlers, innovators, dreamers, coaches, creators, builders, champions, leaders, trailblazers, go-getters, visionaries, game-changers, risk-takers, grinders, athletes, mentors, pioneers, self-starters, doers, warriors, strivers, competitors, underdogs, MVPs, trainers, founders, disruptors, the relentless, the passionate, the driven, the fearless, the dedicated, the unstoppable, ';
const WORDWALL_TEXT = WORDWALL_PHRASE.repeat(12);

export default function LoggedOutPage() {
  const navigate = useNavigate();
  const [bgColor] = useState(() => DOT_COLORS[Math.floor(Math.random() * DOT_COLORS.length)]);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="signedout-bg" style={{ backgroundColor: bgColor }}>
      <div className="signedout-wordwall" aria-hidden="true">{WORDWALL_TEXT}</div>
      <a href="https://polyp.me" className="signedout-brand"><em>Polyp.</em></a>

      <div className={`signedout-card ${visible ? "visible" : ""}`}>
        <div className="signedout-wave-dots">
          <span className="signedout-wave-dot" />
          <span className="signedout-wave-dot" />
          <span className="signedout-wave-dot" />
          <span className="signedout-wave-dot" />
          <span className="signedout-wave-dot" />
        </div>

        <h1 className="signedout-title">You've been signed out</h1>
        <p className="signedout-sub">See you next time.</p>

        <button className="signedout-btn" onClick={() => navigate("/login")}>
          Sign back in
        </button>
      </div>
    </div>
  );
}
